import React, {useEffect} from 'react';
import {MainTop} from "../../main-top/Main-top";
import {ReactComponent as BackIcon} from '../../../../../../assets/main/groups/main-top/back.svg';
import {
    StudentsStatistic
} from "components/pages/groups/group-container/students/students-pages/students-statistic/StudentsStatistic";
import {StudentsTabs} from "./students-tabs/Students-tabs";
import {StudentsHomeWorks} from "./students-tabs/students-home-works/StudentsHomeWorks";
import {StudentsLessons} from "./students-tabs/students-lessons/Students-lessons";
import {StudentsSlices} from "./students-slices/StudentsSlices";
import {
    StudentsTimetable
} from "components/pages/groups/group-container/students/students-pages/students-timetable/StudentsTimetable";
import {useAppDispatch, useAppSelector} from "common/hook";
import AuthWrapper from "../../../../../auth-wrapper/AuthWrapper";
import {fetchStudentInfo} from "features/model/service/student-info/fetchStudentInfo";
import {useParams} from 'react-router-dom';
import {
    fetchStudentLessons
} from "features/model/service/student-info/student-info-lessons/fetchStudentInfoLessons";
import {fetchCalendar} from "features/model/service/calendar/calendar";


export const StudentsPages = () => {
    const dispatch = useAppDispatch()
    const activeTab = useAppSelector((state) => state.topTabs.activeTabs);
    const roleType = useAppSelector((state) => state.role.roleType);
    const studentInfo = useAppSelector((state) => state.studentInfo);
    const {data} = studentInfo
    const demo = data?.demo
    const {groupId, studentId} = useParams();


    useEffect(() => {
        dispatch(fetchStudentInfo({groupId, studentId}));
    }, [groupId, studentId]);


    useEffect(() => {
        dispatch(fetchStudentLessons({groupId, studentId}));
    }, [groupId, studentId]);




    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title="Студент"
                    tabs={false}
                    setting={false}
                    edit={false}
                    link={`/groups/${groupId}`}
                    icons={<BackIcon/>}
                    onlineTabs={false}
                />
                <StudentsStatistic/>
                {(demo && roleType === 'teacher') ? null : <StudentsTabs/>}
                {activeTab.includes(0) && <StudentsLessons/>}
                {activeTab.includes(1) && <StudentsHomeWorks/>}
                {activeTab.includes(2) && <StudentsSlices/>}
                {activeTab.includes(3) && <StudentsTimetable/>}
            </div>
        </AuthWrapper>
    );
};

